import { render, staticRenderFns } from "./stakeCoin.vue?vue&type=template&id=d6862c90&"
import script from "./stakeCoin.vue?vue&type=script&lang=js&"
export * from "./stakeCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports